module.exports = __webpack_public_path__ + "static/media/1015021.eebecb34.jpg";